import React from 'react';
import ParallaxSection from './ParallaxSection';
import SectionHeading from './SectionHeading';
import Button from './Button';
import { useScrollToContact } from '../hooks/useScrollToContact';

const aircraft = [
  {
    name: 'Ikarus C42',
    category: 'Motorflugzeug',
    description: 'Modernes Ultraleichtflugzeug mit hervorragenden Flugeigenschaften, ideal für die Grundausbildung und Rundflüge.',
  },
  {
    name: 'L23 Super Blanik',
    category: 'Segelflugzeug',
    description: 'Zweisitziges Schulungsflugzeug aus Metall mit guten Flugeigenschaften.',
  },
  {
    name: 'Pirat',
    category: 'Segelflugzeug',
    description: 'Beliebtes Einsitzer-Segelflugzeug für den Vereinsbetrieb.',
  },
];

const Aircraft: React.FC = () => {
  const scrollToContact = useScrollToContact();

  return (
    <ParallaxSection
      id="flugzeuge"
      backgroundImage="/images/Flugsportverein_Bilder_6.jpg"
    >
      <div>
        <SectionHeading
          eyebrow="Flugzeuge"
          title="Unsere Flotte"
          subtitle="Unsere Flugzeuge bieten die perfekte Grundlage für Ihre Flugausbildung."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {aircraft.map((plane) => (
            <div key={plane.name} className="bg-white shadow overflow-hidden rounded-lg p-4">
              <span className="inline-block bg-gray-100 rounded-full px-3 py-1 text-sm font-semibold text-gray-600 mr-2 mb-2">
                {plane.category}
              </span>
              <h3 className="text-lg font-medium text-gray-900">{plane.name}</h3>
              <p className="mt-1 text-sm text-gray-500">{plane.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Button href="#kontakt" onClick={scrollToContact}>
            Interessiert an einem Probeflug? Kontaktieren Sie uns!
          </Button>
        </div>
      </div>
    </ParallaxSection>
  );
};

export default Aircraft; 